import React, { Component } from 'react';
import * as $ from 'jquery';
import '../../dropdown-submenu.css';
import { translate } from 'react-i18next';

class UserForm extends Component {

  isSubmitEnabled = () => {
    return this.props.center
  }

  handleCityChange = (city) => {
    const { t } = this.props;
    this.props.handleCityClick(city);
    $("#selected_center").text(t('guest.survey.holder_center'));
  }

  renderCenter = (center, index) => {
    return(
      <li key={index}>
        <a onClick={() => this.props.handleCenterClick(center)}>
          <span style={{textTransform: "uppercase"}}>
            {center.name}
          </span>
        </a>
      </li>
    );
  }

  renderCity = (city, index) => {
    return(
      <li key={index}>
        <a onClick={() => this.handleCityChange(city)} >
          <span style={{textTransform: "uppercase"}}>
            {city.name}
          </span>
        </a>
      </li>
    );
  }

  render() {
    const { t } = this.props;
    return(
      <div>
        <div className="jumbotron text-center">
          <div className="row">
            <div className="col-xs-10 col-xs-offset-1">
              <p><small>{t('guest.survey.heading')}</small></p>
            </div>
          </div>
        </div>
        <form method="post" onSubmit={this.props.handleUserForm}>
          <fieldset>
            <div className="panel panel-default">
              <div className="panel-heading">
                <h4 className="panel-title">{t('guest.survey.heading_user')}</h4>
              </div>
              <div className="panel-body">
                <div className="row">

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="name">
                        {t('guest.survey.label_name')}
                      </label>
                      <input
                        className="form-control"
                        id="name"
                        onChange={this.props.handleNameChange}
                        placeholder={t('guest.survey.holder_name')}
                        type="text"
                        value={this.props.name} />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="company">
                        {t('guest.survey.label_company')}
                      </label>
                      <input
                        className="form-control"
                        id="company"
                        onChange={this.props.handleCompanyChange}
                        placeholder={t('guest.survey.holder_company')}
                        type="text"
                        value={this.props.company} />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="email">
                        {t('guest.survey.label_email')}
                      </label>
                      <input
                        className="form-control"
                        id="email"
                        onChange={this.props.handleEmailChange}
                        placeholder={t('guest.survey.holder_email')}
                        type="email"
                        value={this.props.email} />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="phone">
                        {t('guest.survey.label_phone')}
                      </label>
                      <input
                        className="form-control"
                        id="phone"
                        onChange={this.props.handlePhoneChange}
                        placeholder={t('guest.survey.holder_phone')}
                        type="tel"
                        value={this.props.phone} />
                    </div>
                  </div>

                   <div className="col-md-6">

                      <div className="form-group">
                        <label htmlFor="city">
                          <span style={{color: "red"}}>*&nbsp;</span>
                          {t('guest.survey.label_city')}
                        </label>
                        <div className="dropdown">
                          <button
                            className="btn btn-block btn-default"
                            data-toggle="dropdown"
                            id="city"
                            type="button">
                            <span style={{float: "left", textTransform: "uppercase"}}>
                              {this.props.city ? this.props.city.name : t('guest.survey.holder_city')}
                            </span>
                            <span className="caret" style={{float: "right"}} />
                          </button>
                          <ul className="dropdown-menu">
                            {this.props.cities.map((city, index) => this.renderCity(city, index))}
                          </ul>
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="center">
                          <span style={{color: "red"}}>*&nbsp;</span>
                          {t('guest.survey.label_center')}
                        </label>
                        <div className="dropdown">
                          <button
                            className="btn btn-block btn-default"
                            data-toggle="dropdown"
                            id="center"
                            type="button">
                            <span id="selected_center" style={{float: "left", textTransform: "uppercase"}}>
                              {this.props.center ? this.props.center.name : t('guest.survey.holder_center')}
                            </span>
                            <span className="caret" style={{float: "right"}} />
                          </button>
                          <ul className="dropdown-menu">
                            {this.props.centers.map((center, index) => this.renderCenter(center, index))}
                          </ul>
                        </div>
                      </div>

                  </div>

                   <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="suite">
                        {t('guest.survey.label_suite')}
                      </label>
                      <input
                        className="form-control"
                        id="suite"
                        onChange={this.props.handleSuiteChange}
                        placeholder={t('guest.survey.holder_suite')}
                        type="text"
                        value={this.props.suite} />
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div className="form-group text-center">
              <button
                className="btn btn-primary"
                disabled={!this.isSubmitEnabled()}
                type="submit">
                {t('guest.survey.btn_continue')}
              </button>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

export default translate('common')(UserForm);



// WEBPACK FOOTER //
// ./src/guest/survey/UserForm.js